import { render } from "./ValidationDocumentList.vue?vue&type=template&id=34af14be&scoped=true&ts=true"
import script from "./ValidationDocumentList.vue?vue&type=script&lang=ts"
export * from "./ValidationDocumentList.vue?vue&type=script&lang=ts"

import "./ValidationDocumentList.vue?vue&type=style&index=0&id=34af14be&lang=scss&scoped=true"

import exportComponent from "/home/vsts/work/1/s/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34af14be"]])

export default __exports__